if (!customElements.get('tt-product-detail')) {
  customElements.define(
    'tt-product-detail',
    class TenderTraceProductDetail extends HTMLElement {
      connectedCallback() {
        this.mainImage = this.querySelector('.tt-pdp__main-image');
        this.thumbnails = Array.from(this.querySelectorAll('[data-tt-thumbnail]'));
        this.index = 0;
        this.touchStartX = 0;

        this.thumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => this.showImage(index));
        });

        this.querySelector('[data-tt-prev]')?.addEventListener('click', () => this.step(-1));
        this.querySelector('[data-tt-next]')?.addEventListener('click', () => this.step(1));

        this.mainImage?.addEventListener('touchstart', (event) => {
          this.touchStartX = event.changedTouches[0].clientX;
        }, { passive: true });

        this.mainImage?.addEventListener('touchend', (event) => {
          const distance = event.changedTouches[0].clientX - this.touchStartX;
          if (Math.abs(distance) > 45) this.step(distance > 0 ? -1 : 1);
        }, { passive: true });

        this.querySelectorAll('[data-tt-quantity]').forEach((button) => {
          button.addEventListener('click', () => {
            const input = this.querySelector('[data-tt-quantity-input]');
            if (!input) return;
            const direction = Number(button.dataset.ttQuantity);
            input.value = Math.max(1, Number(input.value || 1) + direction);
          });
        });

        this.querySelector('[data-tt-variant-select]')?.addEventListener('change', (event) => {
          const option = event.target.selectedOptions[0];
          const form = this.querySelector('.tt-pdp__form');
          const price = this.querySelector('[data-tt-price]');
          const submit = this.querySelector('[data-tt-submit]');
          if (form) form.querySelector('[name="id"]').value = option.value;
          if (price) price.textContent = option.dataset.price;
          if (submit) {
            submit.disabled = option.dataset.available !== 'true';
            submit.textContent = option.dataset.available === 'true' ? submit.dataset.addText : submit.dataset.soldText;
          }
        });
      }

      step(direction) {
        if (!this.thumbnails.length) return;
        this.showImage((this.index + direction + this.thumbnails.length) % this.thumbnails.length);
      }

      showImage(index) {
        const thumbnail = this.thumbnails[index];
        if (!thumbnail || !this.mainImage) return;
        this.index = index;
        this.mainImage.src = thumbnail.dataset.imageUrl;
        this.mainImage.srcset = '';
        this.mainImage.alt = thumbnail.dataset.imageAlt;
        this.thumbnails.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === index);
          item.setAttribute('aria-current', itemIndex === index ? 'true' : 'false');
        });
      }
    }
  );
}
